import React from "react";

const BlueTick = (fill = "#4C70EF") => (
  <svg
    width="11"
    height="9"
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2246 1.62453L3.82458 8.02453C3.76883 8.08046 3.7026 8.12485 3.62967 8.15513C3.55674 8.18541 3.47854 8.201 3.39958 8.201C3.32061 8.201 3.24242 8.18541 3.16948 8.15513C3.09655 8.12485 3.03032 8.08046 2.97458 8.02453L0.174576 5.22453C0.118764 5.16872 0.0744917 5.10246 0.0442866 5.02954C0.0140815 4.95661 -0.00146484 4.87846 -0.00146484 4.79953C-0.00146484 4.7206 0.0140815 4.64244 0.0442866 4.56952C0.0744917 4.4966 0.118764 4.43034 0.174576 4.37453C0.230388 4.31872 0.296646 4.27444 0.369567 4.24424C0.442489 4.21403 0.520646 4.19849 0.599576 4.19849C0.678506 4.19849 0.756663 4.21403 0.829584 4.24424C0.902506 4.27444 0.968764 4.31872 1.02458 4.37453L3.40008 6.75003L9.37557 0.775528C9.48829 0.662811 9.64117 0.599487 9.80057 0.599487C9.95998 0.599487 10.1129 0.662811 10.2256 0.775528C10.3383 0.888245 10.4016 1.04112 10.4016 1.20053C10.4016 1.35993 10.3383 1.51281 10.2256 1.62553L10.2246 1.62453Z"
      fill={fill}
    />
  </svg>
);

export default BlueTick;
